<div *ngIf="!editando" [class.inline-edit-preview]="modoEditar" (click)="activarEdicion()">
  <ng-content></ng-content>
</div>

<div *ngIf="editando" [ngSwitch]="type" class="inline-edit-form">
 
  <input *ngSwitchCase="'text'"
         type="text"
         [class]="inputClass"
         [(ngModel)]="valorTemporal"
         [placeholder]="placeholder"
         (blur)="guardarCambios()"
         (keyup.enter)="guardarCambios()"
         appAutofocus>

  <textarea *ngSwitchCase="'textarea'"
            [class]="inputClass"
            [(ngModel)]="valorTemporal"
            [placeholder]="placeholder"
            (blur)="guardarCambios()"
            (keyup.enter)="guardarCambios()"
            rows="3"
            appAutofocus></textarea>

  <input *ngSwitchCase="'date'"
         type="date"
         [class]="inputClass"
         [(ngModel)]="valorTemporal"
         (blur)="guardarCambios()"
         (keyup.enter)="guardarCambios()"
         appAutofocus>

  <select *ngSwitchCase="'select'"
          [ngClass]="inputClass"
          [(ngModel)]="valorTemporal"
          (blur)="guardarCambios()"
          (change)="guardarCambios()"
          appAutofocus>
    <option *ngIf="placeholder" [value]="''" disabled>{{ placeholder }}</option>
    
    <ng-container *ngFor="let opt of options">
      <option [value]="opt.value !== undefined ? opt.value : opt">
        {{ opt.label !== undefined ? opt.label : opt }}
      </option>
    </ng-container>
  </select>

</div>